import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgQuestionStatusUngradedIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", { children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M11.7333 0H4.26667C1.91025 0 0 1.91025 0 4.26667V11.7333C0 14.0897 1.91025 16 4.26667 16H11.7333C14.0897 16 16 14.0897 16 11.7333V4.26667C16 1.91025 14.0897 0 11.7333 0Z",
			fill: "#D3DDF2"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.6315 10.9334C8.6315 11.2821 8.34872 11.5649 7.99998 11.5649C7.65124 11.5649 7.36847 11.2821 7.36847 10.9334C7.36847 10.5847 7.65124 10.3019 7.99998 10.3019C8.34872 10.3019 8.6315 10.5847 8.6315 10.9334Z",
			fill: "#344054",
			stroke: "#344054",
			strokeWidth: .0625
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8 4.7406V8.97764",
			stroke: "#344054",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8 13.8666C11.2401 13.8666 13.8667 11.2401 13.8667 7.99997C13.8667 4.7599 11.2401 2.1333 8 2.1333C4.7599 2.1333 2.13333 4.7599 2.13333 7.99997C2.13333 11.2401 4.7599 13.8666 8 13.8666Z",
			stroke: "#344054",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	] })
});
export default SvgQuestionStatusUngradedIcon;
